export default __webpack_public_path__ + "static/media/Paper_Upload.b19d8b9d.svg";